import React, { Component } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import { confirmAlert } from 'react-confirm-alert';
import { toast } from 'react-toastify';
import services from '@C/LiveMemo/_utils/data';
import { formatCurrency, TableGrid } from '@C/TableGrid';
import DropLoaderLarge from '@C/Utils/DropLoaderLarge';
import { authHeader } from '@H';
import { DateRangeFilter } from '@C/Utils';
const col = [
  {
    name: 'Date',
    key: 'time_stamp',
    sortable: true,
    type: 'date',
  },
  {
    name: 'Customer',
    key: 'customer_name',
  },

  {
    name: 'Product',
    key: 'product_list',
    formatter(props) {
      return (
        <>
          {props.map((item, i) => (
            <React.Fragment key={i}>
              {item.product.name}
              <hr />
            </React.Fragment>
          ))}
        </>
      );
    },
  },
  {
    name: 'Price',
    key: 'product_list',
    formatter(props) {
      return (
        <>
          {props.map((item, i) => (
            <React.Fragment key={i}>
              {item.price.toFixed(2)}
              <hr />
            </React.Fragment>
          ))}
        </>
      );
    },
  },
  {
    name: 'Quantity',
    key: 'product_list',
    formatter(props) {
      return (
        <>
          {props.map((item, i) => (
            <React.Fragment key={i}>
              {item.quantity}
              <hr />
            </React.Fragment>
          ))}
        </>
      );
    },
  },
  {
    name: 'Discount',
    key: 'product_list',
    formatter(props) {
      return (
        <>
          {props.map((item, i) => (
            <React.Fragment key={i}>
              {item.discount.toFixed(2)}
              <hr />
            </React.Fragment>
          ))}
        </>
      );
    },
  },
  {
    name: 'Vehicle',
    key: 'vehicle',
  },
  {
    name: 'Payment mode',
    key: 'source',
  },
  {
    name: 'Total amount',
    key: 'all',
    formatter(props) {
      return <>{formatCurrency(props.after_tax)}</>;
    },
  },
];

const enabledActions = [
  {
    action: 'Delete',
    roles: ['Dealer', 'Manager'],
  },
  {
    action: 'Memo PDF',
    roles: ['Dealer', 'Manager'],
  },
  {
    action: 'Print Memo',
    roles: ['Dealer', 'Manager'],
  },
];

class GeneratedBillList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      liveMemoList: [],
      selectedId: '',
      showModal: false,
      loading: false,
      start_date: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
      end_date: dayjs().format('YYYY-MM-DD'),
      limit: 20,
      offset: 1,
      count: 0,
    };

    this.limitInput = React.createRef();
  }

  componentDidMount() {
    this.getLiveMemoList();
  }

  handlePagination = (e) => {
    this.setState({ offset: e }, function () {
      this.getLiveMemoList();
    });
  };
  handleDateChange = (e) => {
    const { name, value } = e.target;
    if (name === 'start_date' && dayjs(value).isAfter(this.state.end_date)) {
      this.setState({ [name]: value, end_date: value });
    } else if (
      name === 'end_date' &&
      dayjs(value).isBefore(this.state.start_date)
    ) {
      this.setState({ [name]: value, start_date: value });
    } else {
      this.setState({ [name]: value });
    }
  };

  handleQuickSearch = (e) => {
    e.preventDefault();
    if (
      this.limitInput.current.value === '' ||
      this.limitInput.current.value === '0'
    ) {
      return;
    }
    this.setState(
      { limit: this.limitInput.current.value, offset: 1 },
      function () {
        this.getLiveMemoList();
      },
    );
  };

  getLiveMemoList = () => {
    services
      .getLiveMemoList(this.state)
      .then((response) => {
        this.setState({
          liveMemoList: response.data.data.results,
          loading: false,
          count: response.data.data.count,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  resetFilter = () => {
    this.setState(
      {
        start_date: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
        end_date: dayjs().format('YYYY-MM-DD'),
        limit: 20,
        offset: 1,
        count: 0,
      },
      function () {
        this.getLiveMemoList();
      },
    );
  };

  confirmDelete = (item) => {
    confirmAlert({
      title: 'Confirm live memo deletion',
      message: 'Are you sure',
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.deleteItem(item),
        },
        {
          label: 'No',
          onClick: () => false,
        },
      ],
    });
  };

  deleteItem = (item) => {
    const headers = authHeader(1);
    axios
      .delete(
        `${process.env.API_URL}/credit-customer/bunk/live-memo/?memo_id=${item.uuid}`,
        {
          headers,
        },
      )
      .then(() => {
        toast.success('Live memo deleted successfully');
        this.getLiveMemoList();
      })
      .catch((error) => {
        toast.error('Error deleting memo');
      });
  };

  submitForm = (e) => {
    e.preventDefault();
    this.setState({ loading: true }, function () {
      this.getLiveMemoList();
    });
  };

  render() {
    const { liveMemoList } = this.state;
    return (
      <section className="widget full-width list-table">
        <header className="list-header">
          <h3>Memo List</h3>
        </header>
        <main>
          {!this.props.cod && (
            <div className="table-filters">
              <div className="filter-wrapper">
                <div className="filter-group with-icon">
                  <label>
                    Results to display- {this.state.limit || 20} (Total:{' '}
                    {this.state.count})
                  </label>
                  <form onSubmit={this.handleQuickSearch}>
                    <input type="text" name="limit" ref={this.limitInput} />
                    <button
                      type="submit"
                      className="search-icon"
                      onClick={this.handleQuickSearch}
                    />
                  </form>
                </div>
                <div className="filter-group">
                  <label>Date range:</label>
                  <DateRangeFilter
                    value={[this.state.start_date, this.state.end_date]}
                    onChange={(dates) => {
                      this.setState({
                        start_date: dates[0],
                        end_date: dates[1],
                      });
                    }}
                    limit={6}
                  />
                </div>
                <div className="filter-group reset-filter">
                  <button onClick={this.resetFilter}>Reset filters</button>
                </div>
                <div className="filter-group">
                  <button
                    className="submit"
                    type="submit"
                    onClick={this.submitForm}
                  >
                    Apply filter
                  </button>
                </div>
              </div>
            </div>
          )}
          <div className="table-wrapper">
            {(() => {
              if (this.state.loading) {
                return <DropLoaderLarge />;
              } else {
                return (
                  <>
                    <TableGrid
                      col={col}
                      row={liveMemoList}
                      offset={this.state.offset}
                      count={this.state.count}
                      limit={this.state.limit}
                      handlePagination={this.handlePagination}
                      onEdit={this.props.onEdit}
                      onDelete={this.confirmDelete}
                      enabledActions={enabledActions}
                    />
                  </>
                );
              }
            })()}
          </div>
        </main>
      </section>
    );
  }
}

export default GeneratedBillList;
